import React, { Component } from 'react';
import {darkMode} from '../../Utils.js';
import {Carousel} from '../../components/Carousel/Carousel.js'
import Projectcard from '../../components/Projectcard/Projectcard.js'
import './Home.scss'
import TitleLoop from '../../components/TitleLoop/TitleLoop.js'
import {t} from "../../lang/i18n.js";

import {Link} from "react-router-dom";
export class Home extends Component {

  constructor(props) {
    super(props);

    let darkMode = false;
    this.state = { data: {}, network: true, darkMode : darkMode, titles: false };

  }

  componentDidMount() {
    darkMode(this.state.darkMode);
    this.setState({network: false});

  }

  componentDidUpdate() {

  }

  fetchPostData() {

  }


  render() {
    if (!this.state.network) {
      return (
        <main>
          <HeroProjects data={this.props.content} projects={this.props.projects} />
          <ShowcaseProjects data={this.props.content} projects={this.props.projects} />
        </main>
      )
    } else {
      return (
        <main>

        </main>
      )
    }
  }
}



export class HeroProjects extends Component {

    constructor(props) {
      super(props);

      const projectsLength = (typeof this.props.data !== 'undefined') ? this.props.data.custom_fields.featured_projects.length : [];
      const projectsArray = (typeof this.props.data !== 'undefined') ? Object.values(this.props.data.custom_fields.featured_projects) : [];

      this.state = {projectsArray: projectsArray, projectsLength : projectsLength,  projects : [], network: true, error: false};
      this.populatePageAfterFetch = this.populatePageAfterFetch.bind(this);

    }

    componentDidMount() {
      //this.setState({network: true});
      this.populatePageAfterFetch(this.state.projectsArray);
    }

    populatePageAfterFetch(projectsArray) {

      let projectsIDArray = [];
      for (let i = 0; i < projectsArray.length; i++) {
        projectsIDArray.push(projectsArray[i].ID);
      }

      let totalProjects = this.props.projects;

      let objLength = Object.keys(totalProjects).length;
      let projects = [];

      for (let i = 0; i < objLength; i++) {

        let objKey = Object.values(totalProjects)[i].id;

        if (projectsIDArray.indexOf( objKey ) >= 0) {
          let currentProject = {};
          currentProject.title = Object.values(totalProjects)[i].title.rendered;
          currentProject.description = Object.values(totalProjects)[i].content.rendered;
          currentProject.url = Object.values(totalProjects)[i].link;
          currentProject.featured_image = Object.values(totalProjects)[i]['featured_image_url'];
          //currentProject.featured_animated_image = (Object.values(totalProjects)[i].acf.featured_animated_image) ? Object.values(totalProjects)[i].acf.featured_animated_image.url : false;
          currentProject.featured_animated_image = false;

          projects.push(currentProject);
        }
      }
      this.setState({projects : projects, network: false});
    }


    render() {

    const settings = {
         dots: false,
         arrows: true,
         infinite: true,
         speed: 2000,
         slidesToShow: 1,
         slidesToScroll: 1,
         centerMode : true,
         centerPadding : 0,
         variableWidth : true,
         autoplay: true,
         autoplaySpeed: 6000,

         responsive : [
           {
             breakpoint: 680,
             settings: {
               centerPadding : '5px',
              }
           },
         ]
       };

    return (
        <section className="hero" data-scroll data-scroll-class="inview">
          <div className="hero__inner">
            <div className="hero__content">
              <Carousel type="featuredprojects" settings={settings}>
                {this.state.projects && this.state.projects.map((project, index) => {
                  return (
                    <div className="slider__item" key={index}>
                      <Projectcard cinema={true} size="projectcard--large" title={project.title} featuredimageanimated={project.featured_animated_image} featuredimage={project.featured_image} url={project.url} />
                    </div>
                  )
                })}

              </Carousel>
            </div>
          </div>
        </section>
      )
    }


}

export class ShowcaseProjects extends Component {

    constructor(props) {
      super(props);

      const projectsType = (typeof this.props.data !== 'undefined') ? this.props.data.custom_fields.last_work_type : 'auto';
      const projectsLength = (typeof this.props.data !== 'undefined') ? Number(this.props.data.custom_fields.last_work_quantity) : 2;
      const projectsArray = (projectsType === 'auto') ? false : Object.values(this.props.data.custom_fields.last_work_manual_projects);
      const title = (typeof this.props.data !== 'undefined') ? this.props.data.custom_fields.last_work_title : '';

      this.state = {darkMode : false, projectsArray: projectsArray, projectsLength : projectsLength,  projects : [], title : title, network: true, error: false};
      this.populatePageAfterFetch = this.populatePageAfterFetch.bind(this);

    }

    componentDidMount() {

      darkMode(this.state.darkMode)
      this.populatePageAfterFetch(this.state.projectsArray, this.state.projectsLength);
    }

    populatePageAfterFetch(projectsArray, projectsLength) {

      let projectsIDArray = [];

      if (projectsArray) {
        for (let i = 0; i < projectsArray.length; i++) {
          projectsIDArray.push(projectsArray[i].ID);
        }
      }

      let totalProjects = this.props.projects;
      let objLength = Object.keys(totalProjects).length;
      let projects = [];

      for (let i = 0; i < objLength; i++) {

        let objKey = Object.values(totalProjects)[i].id;

        let addtoarray = (!projectsArray) ? (projectsLength > i) : projectsIDArray.indexOf( objKey ) >= 0;

        if (addtoarray) {
          let currentProject = {};
          currentProject.title = Object.values(totalProjects)[i].title.rendered;
          currentProject.description = Object.values(totalProjects)[i].content.rendered;
          currentProject.url = Object.values(totalProjects)[i].link;
          currentProject.featured_image = Object.values(totalProjects)[i]['featured_image_url'];
          currentProject.featured_animated_image = (Object.values(totalProjects)[i].acf.featured_animated_image) ? Object.values(totalProjects)[i].acf.featured_animated_image.url : false;

          projects.push(currentProject);
        }

      }

      this.setState({projects : projects, network: false});
    }

    render() {

    const settings = {
         dots: false,
         arrows: true,
         infinite: false,
         speed: 800,
         slidesToShow: 1,
         slidesToScroll: 1,
         centerMode : true,
         centerPadding : '90px',
         variableWidth : true,
         responsive: [
           {
             breakpoint: 1999,
             settings: {
               centerPadding : '20px'
             }
           },
           {
             breakpoint: 680,
             settings: 'unslick'
           }
         ]
       };

    let projects = this.state.projects;
    const projectsRows = projects.reduce(function (rows, key, index) {
        return (index % 2 == 0 ? rows.push([key])
          : rows[rows.length-1].push(key)) && rows;
      }, []);

    let num = 0;
    const zeroPad = (num, places) => String(num).padStart(places, '0');

    const moreLink = '/en/work/';

    return (
        <section className="module module--showcase" >
          <div className="module__inner">
            <header className="module__header">
              <div className="module__header__inner">
                <h2 className="module__header__title">
                  <TitleLoop title={this.state.title} />
                </h2>
              </div>
            </header>

            <div className="module__body" data-scroll data-scroll-class="inview">
              <div className="module__body__inner">
                <Carousel type="showcaseprojects" settings={settings}>
                  {projectsRows && projectsRows.map((projectRow, index) => {
                    return (
                      <div className="slider__row" key={index}>
                        {projectRow.map((item, index2) => {
                          num++;
                          return (
                            <div className="slider__item" key={index2}>
                              <Projectcard index={zeroPad(num, 2)} size="projectcard--medium" title={item.title} featuredimage={item.featured_image} featuredimageanimated={item.featured_animated_image} url={item.url} />
                            </div>
                          )
                        } ) }
                      </div>
                    )
                  })}

                </Carousel>
              </div>
            </div>
            <footer className="module__footer">
              <div className="module__footer__inner">
                <div className="module__footer__section">
                  <Link to={moreLink} className="button button--2">{t('moreprojects')}</Link>
                </div>
              </div>
            </footer>
          </div>
        </section>

      )
    }


}
